import React, { useMemo } from 'react';
import Image from 'next/legacy/image';
import { ProductRelated } from 'types';
import { USER_COVER_PLACEHOLDER_LINK } from 'consts';

import styles from './ProductPage.module.scss';
import CharityLogo from '../../components/CharityLogo';

export type PageRelatedProps = {
  title?: string;
  related?: ProductRelated[];
};

export const PageRelated = ({ title = 'You May Also Like', related }: PageRelatedProps) => {
  if (!related?.length) {
    return null;
  }

  return (
    <div className={styles.related}>
      <h2 className={styles.relatedTitle}>{title}</h2>
      <div className={styles.relatedItems}>{related.map(item => <SimpleGearTile item={item} />)}</div>
    </div>
  );
};

export const SimpleGearTile = ({ item, smaller }) => {
  const isCharity = item.charity_percent===100
  return (
    <div key={item.slug} className={smaller ? styles.relatedItemMid : styles.relatedItem}>
      <div className={smaller ? styles.relatedItemImageMid : styles.relatedItemImage}>
        <a href={`/gear/${item.slug}`}>
          <Image src={item.cover_image || USER_COVER_PLACEHOLDER_LINK} layout="fill" objectFit="cover" alt={item.title} />
          {isCharity && <CharityLogo />}
        </a>
      </div>
      <h3 className={styles.relatedItemTitle}>{item.title}</h3>
      <div className={styles.relatedItemPricing}>
        <p className={styles.price}>{`$${item.price}`}</p>
        {!!item.original_price && <p className={styles.originalPrice}>{`$${item.original_price}`}</p>}
      </div>
    </div>
  );
}
